<ng-container
    *ngTemplateOutlet="isAuthRoute() ? authRoute : defaultLayout"
></ng-container>

<ng-template #authRoute>
    <app-patrol-auth></app-patrol-auth>
</ng-template>

<ng-template #defaultLayout>
    <div class="patrol-layout">
        <div class="patrol-header">
            <div class="patrol-content-shell">
                <app-header-v2
                  [layout]="'patrol'"
                  [navigationButtons]="navigationButtons()"
                  [user]="patrolUser()"
                ></app-header-v2>
            </div>
        </div>
        <main class="patrol-main">
            <div class="patrol-content-shell">
                <router-outlet></router-outlet>
            </div>
        </main>
    </div>
</ng-template>
